/**
 * Created by mongoose on 14/11/17.
 */
import React from "react";
import PropTypes from "prop-types";
import { FormGroup } from "react-bootstrap-3";

/*TODO: set error style*/
function CheckboxGroup({ value, onChange, field }) {
  const { fieldName, description, disabled, className, htmlFor } = field;
  return (
    <div className={className}>
      <FormGroup>
        <div className="checkbox c-checkbox needsclick">
          <label className={`needsclick control-label ${className || ""}`} htmlFor={htmlFor}>
            <input
              disabled={disabled}
              type="checkbox"
              defaultChecked={value}
              checked={value}
              className="needsclick"
              onChange={event => onChange({ event, field: fieldName })}
            />
            <em className="fa fa-check" />
            {description}
          </label>
        </div>
      </FormGroup>
    </div>
  );
}

CheckboxGroup.propTypes = {
  field: PropTypes.object,
  formErrors: PropTypes.object,
  formValues: PropTypes.object,
  hasErrors: PropTypes.bool,
  onChange: PropTypes.func,
};

export default CheckboxGroup;
